<template>
  <div>
    <v-card class="mt-2">
      <div class="d-flex justify-space-between pa-3">
        <span class="headline">
          Block History
        </span>
        <v-btn v-if="allowCreate" @click="modal.create = true" color="primary" outlined>
          Assign Block
        </v-btn>
      </div>
      <v-skeleton-loader v-if="$apollo.loading" type="table" />
      <div v-else>
        <v-card-text v-if="workoutSubscriptionBlocks.edges.length === 0">No Block selected</v-card-text>
        <v-simple-table v-else>
          <thead>
            <tr>
              <th>Active</th>
              <th>Block Type</th>
              <th>Block Title</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Self Paced</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subscription in workoutSubscriptionBlocks.edges" :key="subscription.node.id">
              <th>
                <v-icon
                  :color="blockActive(subscription.node.endDate, subscription.node.isSelfPaced) ? 'green' : 'red'"
                >
                  {{
                    blockActive(subscription.node.endDate, subscription.node.isSelfPaced)
                      ? "mdi-check-circle"
                      : "mdi-close-circle"
                  }}
                </v-icon>
              </th>
              <td>{{ subscription.node.block.type }}</td>
              <td>{{ subscription.node.block.title }}</td>
              <td>{{ subscription.node.startDate }}</td>
              <td>{{ subscription.node.endDate }}</td>
              <td><v-icon v-if="subscription.node.isSelfPaced">mdi-check-circle</v-icon></td>
              <td>
                <div class="d-flex">
                  <v-btn class="mr-2" icon @click="handleEdit(subscription.node.id)" color="primary" outlined small>
                    <v-icon color="secondary">create</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="handleDelete(subscription.node.id, subscription.node.isSelfPaced)"
                    color="primary"
                    outlined
                    small
                  >
                    <v-icon color="secondary">delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card>
    <v-dialog
      v-if="modal.create"
      v-model="modal.create"
      width="500"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <manage-block :userId="userId"></manage-block>
    </v-dialog>
    <v-dialog
      v-if="modal.edit"
      v-model="modal.edit"
      width="500"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <manage-block :subscriptionBlockId="this.selectedSubscriptionBlockId" mode="EDIT" :userId="userId"></manage-block>
    </v-dialog>
  </div>
</template>

<script>
import { SUBSCRIPTION_ACTIVITY_QUERY } from "@/constants/graphql/coach/coaching";
import ManageBlock from "@/components/workout_blocks/ManageBlock";
import { COACHING_BLOCK_MUTATION } from "@/constants/graphql/blocks/workoutblocks";
import { decodeId } from "@/lib/string";

export default {
  name: "BlockHistory",
  components: {
    ManageBlock,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      workoutSubscriptionBlock: null,
      selectedSubscriptionBlockId: null,
      modal: {
        create: false,
        edit: false,
      },
    };
  },
  methods: {
    handleEdit(id) {
      this.selectedSubscriptionBlockId = id;
      this.modal.edit = true;
    },
    handleDelete(id, isSelfPaced) {
      let confirm = window.confirm("Are you sure you want the client to leave this block?");
      if (!confirm) return;
      this.endBlock(id, isSelfPaced);
    },
    endBlock(id, isSelfPaced) {
      let input = {
        subscriptionBlockId: decodeId(id),
        endDate: this.$moment().format("YYYY-MM-DD"),
        isSelfPaced: isSelfPaced,
      };
      this.$apollo
        .mutate({
          mutation: COACHING_BLOCK_MUTATION,
          variables: {
            input: input,
          },
          refetchQueries: ["subscriptionActivityQuery"],
        })
        .then((result) => {
          this.saving = false;
          if (result.data.coachingSubscriptionBlockMutation.success) {
            this.$toasted.success("Client has left the block", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          } else {
            this.$toasted.error("Something went wrong", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    blockActive(end, isSelfPaced) {
      const endDate = this.$moment(end, "YYYY-MM-DD").subtract(1, "days");

      if (isSelfPaced && (!end || this.$moment() < endDate)) {
        return true;
      }

      return this.$moment() < endDate;
    },
  },
  apollo: {
    workoutSubscriptionBlocks: {
      query: SUBSCRIPTION_ACTIVITY_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
    },
  },
};
</script>
